var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 5,
    fill: "url(#paint0_linear_418_2)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2762 12.6392C25.6346 11.3741 24.6852 10.2907 23.5154 9.48842C22.3456 8.68617 20.9929 8.19086 19.5817 8.04804C18.9432 7.98399 18.3 7.98399 17.6616 8.04804C16.2504 8.19096 14.8977 8.68625 13.7278 9.48841C12.558 10.2906 11.6085 11.3739 10.9666 12.6388C10.159 14.2527 9.84708 16.0696 10.0701 17.8604C10.2931 19.6513 11.0411 21.3362 12.2198 22.7028L17.9678 29.6912C18.0471 29.7877 18.1469 29.8655 18.2599 29.9189C18.373 29.9723 18.4964 30 18.6214 30C18.7464 30 18.8699 29.9723 18.9829 29.9189C19.0959 29.8655 19.1957 29.7877 19.2751 29.6912L25.023 22.7028C26.2018 21.3363 26.9497 19.6515 27.1727 17.8607C27.3957 16.0698 27.0838 14.2531 26.2762 12.6392ZM18.6214 19.8457C17.952 19.8457 17.2976 19.6472 16.741 19.2753C16.1844 18.9034 15.7506 18.3748 15.4944 17.7563C15.2382 17.1378 15.1712 16.4573 15.3018 15.8007C15.4324 15.1441 15.7547 14.541 16.2281 14.0677C16.7014 13.5943 17.3045 13.272 17.9611 13.1414C18.6177 13.0108 19.2982 13.0778 19.9167 13.334C20.5352 13.5902 21.0638 14.024 21.4357 14.5806C21.8076 15.1372 22.0061 15.7916 22.0061 16.461C22.0051 17.3584 21.6481 18.2187 21.0136 18.8532C20.3791 19.4877 19.5188 19.8446 18.6214 19.8457Z",
    fill: "url(#paint1_linear_418_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_418_2",
    x1: 0,
    y1: 0,
    x2: 37,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70EFDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_418_2",
    x1: 26.0203,
    y1: 11.9728,
    x2: 6.80558,
    y2: 12.4638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGis);
export default __webpack_public_path__ + "static/media/gis .854f5eae629230971bb693ca9db54f68.svg";
export { ForwardRef as ReactComponent };